import React, { Suspense, lazy, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Modal from "react-modal";
import moment from "moment";
import Accordion from "react-bootstrap/Accordion";
// import { useSelector } from "react-redux/es/exports.js";
import { selectAuth, selectUser } from "../../auth/auth.selector.js";
import LightTable from "../../components-bootstrap/LightTable.jsx";
import PaginationLight from "../../components-bootstrap/PaginationLight.jsx";
import ReactModal from "react-modal";
import Loader from "../../ui/Loader.jsx";
import ModalHeader from "../../ModalHeader.jsx";
import {
  fetchAllTrainersData,
  fetchGymsAttendanceData,
  fetchTMTAData,
  fetchTSARData,
  fetchTargetAchievedData,
  fetchTrainersMonthlyTagetData,
} from "../../../redux/reducers/apiSlice";
import ModalHeadAndClose from "../../payouts-wtf/common/ModalHeadAndClose";
import ManageTrainerShifts from "./actions/ManageTrainerShifts";
import ManageTrainerShiftDays from "./actions/ManageTrainerShiftDays";
import { BodyBuilder } from "../../../exports/Images";
import FiltersTrainerDetails from "./common/FiltersTrainerDetails";
import {
  currentMonthName,
  currentMonthNumber,
  currentYear,
  formattedToday,
  formattedTodayDisplay,
} from "../../common-data/Converts";
import AttendanceHistoryDetails from "./admin-level/AttendanceHistoryDetails.jsx";
import TrainerDetailsPage from "./TrainerDetailsPage.jsx";
import TrainerInfo from "./common/TrainerInfo.jsx";
import { isManagerRole as checkIsManagerRole } from "../../common-data/Conversions";

const AddExpertise = lazy(() => import("./AddExpertise.jsx"));
const AddTrainer = lazy(() => import("./AddTrainer.jsx"));

const TrainerDetailsAdmin = ({ selectedGym, queryParametersForAll }) => {
  const dispatch = useDispatch();
  const userInfo = useSelector(selectAuth);
  const { user } = userInfo || {};
  const isAdmin = user?.account_type === "admin";
  const isGym = user?.account_type === "gym";
  const isManagerRole = checkIsManagerRole(user);
  const {
    loading,
    // tssrsLoading,
    // tmtaLoading,
    allTrainersData,
    tsarData,
    tmtaData,
    trainersMonthlyTargetData,
    achievedTargetData,
    allGymAttendanceData,
  } = useSelector((state) => state.api);

  const [isExpertiseModalOpen, setIsExpertiseModalOpen] = useState(false);
  const [isTrainerModalOpen, setIsTrainerModalOpen] = useState(false);
  const decryptedText = useSelector(selectUser);
  const [isPage, setIsPage] = useState(0);
  const [trainersData, setTrainersData] = useState([]);
  const [trainersPagination, setTrainersPagination] = useState([]);
  const [tsarStatsData, setTsarStatsData] = useState({});
  const initalActions = {
    userId: "",
    actionModal: false,
    shiftDaysModal: false,
    actionData: "",
  };
  const [actions, setActions] = useState(initalActions);

  const [allAttendanceData, setAllAttendanceData] = useState("");
  // const {
  //   total_checkin,
  //   total_onTimeCheckins,
  //   total_late_checkins,
  //   checkin_percentage,
  //   missed_checkins_percentage,
  // } = allAttendanceData || {};
  const [allTargetsData, setAllTargetsData] = useState("");
  const [targetAchievedData, setTargetAchievedData] = useState(0);
  const [allGymsTAData, setAllGymsTAData] = useState([]);

  const iniTDFilters = {
    selectedGym: !isAdmin && !isManagerRole
      ? {
          label: isGym ? user?.name : user?.gym_name || "",
          value: user?.gym_id || user?.uid || user?.user_id || "",
        }
      : selectedGym
      ? selectedGym
      : "",
    selectedTrainer: "",
    selectedMonth: {
      label: currentMonthName,
      value: currentMonthNumber,
    },
    selectedYear: {
      label: currentYear,
      value: currentYear,
    },
    searchString: "",
  };
  const [tdFilters, setTdFilters] = useState(iniTDFilters);
  const [sendableQPs, setSendableQPs] = useState(
    !isAdmin && !isManagerRole
      ? `&gym_id=${
          decryptedText?.gym_id || decryptedText?.uid || decryptedText?.user_id
        }`
      : ""
  );

  const iniCardValues = {
    filterType: "",
    cardData: [],
    pagination: [],
    isPage: 0,
  };
  const [cardValues, setCardValues] = useState(iniCardValues);
  const { filterType } = cardValues || {};
  const [cardModal, setCardModal] = useState(false);
  const initialTrainerDetailsInfo = {
    trainerDetailsModal: false,
    trainerDetailsData: {},
  };
  const [trainerDetailsInfo, setTrainerDetailsInfo] = useState(
    initialTrainerDetailsInfo
  );

  const iniDates = {
    startDate: formattedToday,
    endDate: formattedToday,
    selectedDates: formattedTodayDisplay,
  };
  const [startAndEndDate, setStartAndEndDate] = useState(iniDates);

  const selectedDatesQueryParam =
    startAndEndDate?.startDate && startAndEndDate?.endDate
      ? `&date_from=${startAndEndDate.startDate}&date_to=${startAndEndDate.endDate}`
      : "";

  const onClickSearch = () => {
    const searchQP = tdFilters.searchString
      ? `&search=${tdFilters.searchString}`
      : "";

    setSendableQPs((prevs) => prevs + searchQP);
    setIsPage(0);
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      onClickSearch();
    }
  };

  const onClickReset = () => {
    setTdFilters(iniTDFilters);
    setSendableQPs("");
  };

  const onClickCard = (filterType) => {
    setCardModal(true);
    setCardValues((prevs) => ({ ...prevs, filterType }));
  };

  const onCloseModal = () => {
    setCardModal(false);
    setCardValues(iniCardValues);
    setStartAndEndDate(iniDates);
  };

  useEffect(() => {
    setTdFilters((prevs) => ({
      ...prevs,
      selectedGym: selectedGym
        ? selectedGym
        : !isAdmin
        ? {
            label: isGym ? user?.name : user?.gym_name || "",
            value: user?.gym_id || user?.uid || user?.user_id || "",
          }
        : "",
    }));
  }, [selectedGym, user?.gym_id]);

  useEffect(() => {
    const monthQP = tdFilters.selectedMonth?.value
      ? `&month=${tdFilters.selectedMonth.value}`
      : "";
    const yearQP = tdFilters.selectedYear?.value
      ? `&year=${tdFilters.selectedYear.value}`
      : "";
    const gymQP = tdFilters.selectedGym?.value
      ? `&gym_id=${tdFilters.selectedGym.value}`
      : "";
    const trainerQP = tdFilters.selectedTrainer?.value
      ? `&trainer_id=${tdFilters.selectedTrainer.value}`
      : "";
    const sendableQUeryParam = `${monthQP}${yearQP}${gymQP}${trainerQP}`;
    setSendableQPs(sendableQUeryParam);
    setIsPage(0);
  }, [
    tdFilters.selectedMonth,
    tdFilters.selectedYear,
    tdFilters.selectedGym,
    tdFilters.selectedTrainer,
  ]);

  useEffect(() => {
    dispatch(
      fetchAllTrainersData({
        pageNo: isPage + 1,
        queryParameters: `&is_pt=1` + sendableQPs,
        token: decryptedText?.token,
      })
    );
  }, [sendableQPs, isPage]);

  useEffect(() => {
    if (sendableQPs) {
      dispatch(
        fetchTSARData({
          queryParameters: sendableQPs,
          token: decryptedText?.token,
        })
      );

      let updatedSendableQPs = sendableQPs.replace("trainer_id", "user_id");

      dispatch(
        fetchTMTAData({
          queryParameters: updatedSendableQPs,
          token: decryptedText?.token,
        })
      );

      dispatch(
        fetchTargetAchievedData({
          queryParameters: sendableQPs,
          token: decryptedText?.token,
        })
      );

      dispatch(
        fetchTrainersMonthlyTagetData({
          queryParameters: sendableQPs,
          token: decryptedText?.token,
        })
      );
    }
  }, [sendableQPs]);

  useEffect(() => {
    if (sendableQPs && selectedDatesQueryParam) {
      dispatch(
        fetchGymsAttendanceData({
          queryParameters: sendableQPs + selectedDatesQueryParam,
          token: decryptedText?.token,
        })
      );
    }
  }, [sendableQPs, selectedDatesQueryParam]);

  useEffect(() => {
    if (allTrainersData?.status && allTrainersData?.data?.length > 0) {
      setTrainersData(allTrainersData.data);
      setTrainersPagination(allTrainersData?.pagination);
    } else {
      setTrainersData([]);
      setTrainersPagination([]);
    }
  }, [allTrainersData]);

  useEffect(() => {
    if (tdFilters.searchString?.length === 0) {
      setIsPage(0);
      setSendableQPs((prevs) => prevs.replace(/&search=[^&]*/, ""));
    }
  }, [tdFilters.searchString]);

  useEffect(() => {
    if (tsarData?.status && tsarData?.data?.length > 0) {
      setTsarStatsData(tsarData.data?.[0]);
    } else {
      setTsarStatsData([]);
    }
  }, [tsarData]);

  useEffect(() => {
    if (tmtaData?.status && tmtaData?.data) {
      const { target_acheived } = tmtaData.data || {};

      setTargetAchievedData(target_acheived);
    } else {
      setTargetAchievedData(0);
    }
  }, [tmtaData]);

  useEffect(() => {
    if (
      trainersMonthlyTargetData?.status &&
      trainersMonthlyTargetData?.data?.length > 0
    ) {
      const allTargetValue = trainersMonthlyTargetData.data.reduce(
        (sum, tar) => sum + parseInt(tar.target_value),
        0
      );
      const allPtValue = trainersMonthlyTargetData.data.reduce(
        (sum, tar) => sum + parseInt(tar.addon_pt || 0),
        0
      );
      const allAddonValue = trainersMonthlyTargetData.data.reduce(
        (sum, tar) => sum + parseInt(tar.addon || 0),
        0
      );
      const allRegularValue = trainersMonthlyTargetData.data.reduce(
        (sum, tar) => sum + parseInt(tar.regular || 0),
        0
      );

      setAllTargetsData({
        target_value: allTargetValue,
        addon_pt: allPtValue,
        regular: allRegularValue,
        addon: allAddonValue,
      });
    } else {
      setAllTargetsData("");
    }
  }, [trainersMonthlyTargetData]);

  useEffect(() => {
    if (
      // filterType === "monthly_target" &&
      achievedTargetData?.status &&
      achievedTargetData?.data
    ) {
      setAllGymsTAData(achievedTargetData.data);
    } else {
      setAllGymsTAData([]);
    }

    if (
      // filterType === "attendance" &&
      allGymAttendanceData?.status
    ) {
      const { absent_stats, attendanceCardData } = allGymAttendanceData || {};

      setAllGymsTAData(absent_stats?.length > 0 ? absent_stats : []);
      setAllAttendanceData(attendanceCardData ? attendanceCardData : {});
    } else {
      setAllAttendanceData({});
    }
  }, [achievedTargetData, allGymAttendanceData]);

  const allTrainerCols = [
    {
      dataField: "name",
      text: "Trainer Name",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer">
          <img
            src={row?.trainer_profile || BodyBuilder}
            alt={row?.name || "N/A"}
            className="image"
          />
          <p
            className="name hoverBlue"
            style={{
              cursor: "pointer",
              color: "blue",
              textDecoration: "underline",
            }}
            onClick={() => {
              setTrainerDetailsInfo({
                trainerDetailsModal: true,
                trainerDetailsData: row,
              });
            }}
          >
            {row?.name || "N/A"}
          </p>
        </div>
      ),
    },
    {
      dataField: "mobile",
      text: "Number",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer column">
          <p className="info">{row?.mobile || "N/A"}</p>
        </div>
      ),
    },
    {
      dataField: "email",
      text: "Email",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer column">
          <p className="info" style={{ textTransform: "lowercase" }}>
            {row?.email || "N/A"}
          </p>
        </div>
      ),
    },
    {
      dataField: "gym_name",
      text: "Gym Name",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer column">
          <p className="info minWidth150">{row?.gym_name || "N/A"}</p>
        </div>
      ),
    },
    // {
    //   dataField: "reporting_name",
    //   text: "Reporting To",
    //   formatter: (cell, row) => (
    //     <div className="emeberDetailsRowContainer column">
    //       <p className="info">{row?.reporting_name || "N/A"}</p>
    //     </div>
    //   ),
    // },
    // {
    //   dataField: "aadhar_card",
    //   text: "Aadhaar",
    //   formatter: (cell, row) => (
    //     <div className="emeberDetailsRowContainer column">
    //       <p className="info">{row?.aadhar_card ? "Yes" : "No"}</p>
    //     </div>
    //   ),
    // },
    // {
    //   dataField: "pan_card",
    //   text: "PAN",
    //   formatter: (cell, row) => (
    //     <div className="emeberDetailsRowContainer column">
    //       <p className="info">{row?.pan_card ? "Yes" : "No"}</p>
    //     </div>
    //   ),
    // },
    {
      dataField: "date_onboarding",
      text: "Date onboarding",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer column">
          <p className="info" style={{ minWidth: "100px" }}>
            {row?.date_onboarding || "-"}
          </p>
        </div>
      ),
    },
    {
      dataField: "status",
      text: "Status",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer column">
          <p
            className="info"
            style={{
              background: row?.status === "active" ? "#B4E7B9" : "#F6EFEF",
              color: row?.status === "active" ? "#0A701B" : "#F13434",
              borderRadius: "8px",
              padding: "5px 10px",
            }}
          >
            {row?.status || "N/A"}
          </p>
        </div>
      ),
    },
    {
      dataField: "action",
      text: "Action",
      formatter: (cell, row) => (
        <div className="actionButtonContainer">
          <button
            className="actionBtn icon edit"
            onClick={() => {
              setActions({
                ...actions,
                actionModal: true,
                actionData: row,
                userId: row?.user_id,
              });
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="19"
              viewBox="0 0 18 19"
              fill="none"
            >
              <path
                d="M16.6315 3.01662L15.6826 2.1002C15.5515 1.97367 15.3427 1.97731 15.2162 2.10834L14.8725 2.46421C14.746 2.59523 14.7497 2.80403 14.8807 2.93056L15.8297 3.84698C15.9607 3.97351 16.1695 3.96986 16.296 3.83884L16.6397 3.48297C16.7662 3.35194 16.7626 3.14315 16.6315 3.01662Z"
                fill="#BC0909"
              />
              <path
                d="M15.8221 3.38106L15.3477 2.92285L8.70361 9.80296L9.1781 10.2612L15.8221 3.38106Z"
                fill="#BC0909"
              />
              <path
                d="M9.4794 0.0234375H8.48997C8.30782 0.0234375 8.16016 0.171098 8.16016 0.353247V2.0023C8.16016 2.18444 8.30782 2.33211 8.48997 2.33211H9.4794C9.66154 2.33211 9.8092 2.18444 9.8092 2.0023V0.353247C9.8092 0.171098 9.66154 0.0234375 9.4794 0.0234375Z"
                fill="#BC0909"
              />
              <path
                d="M8.82084 17.668C13.1013 17.668 16.5714 14.198 16.5714 9.91752C16.5714 5.63702 13.1013 2.16699 8.82084 2.16699C4.54034 2.16699 1.07031 5.63702 1.07031 9.91752C1.07031 14.198 4.54034 17.668 8.82084 17.668Z"
                fill="#FFFEFE"
                stroke="#BC0909"
                strokeWidth="0.989429"
              />
              <path
                d="M9.48162 4.31112C9.48162 4.0379 9.26013 3.81641 8.9869 3.81641C8.71368 3.81641 8.49219 4.0379 8.49219 4.31112V11.8967C8.49219 12.17 8.71368 12.3915 8.9869 12.3915C9.26013 12.3915 9.48162 12.17 9.48162 11.8967V4.31112Z"
                fill="#BC0909"
              />
              <path
                d="M8.98246 11.0704C9.61998 11.0704 10.1368 10.5536 10.1368 9.91605C10.1368 9.27853 9.61998 8.76172 8.98246 8.76172C8.34494 8.76172 7.82812 9.27853 7.82812 9.91605C7.82812 10.5536 8.34494 11.0704 8.98246 11.0704Z"
                fill="#BC0909"
              />
            </svg>
          </button>
          <button
            className="actionBtn icon calender"
            onClick={() => {
              setActions({
                ...actions,
                shiftDaysModal: true,
                actionData: row,
                userId: row?.user_id,
              });
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="22"
              height="22"
              viewBox="0 0 22 22"
              fill="none"
            >
              <g clipPath="url(#clip0_13441_2960)">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M11.6869 4.81395V5.50076C11.678 5.94007 11.1947 6.29688 10.7725 6.14838C10.5065 6.05488 10.3195 5.78538 10.3133 5.50076V4.81395H8.25354C7.71867 4.78851 7.36873 4.10032 7.73448 3.67751C7.83486 3.56201 7.97304 3.48226 8.1236 3.45338C8.18067 3.44238 8.19579 3.44376 8.25354 3.44101H10.3133V2.7542C10.316 2.64213 10.3264 2.6057 10.3477 2.5397C10.4391 2.26332 10.7203 2.06738 11.0139 2.06738C11.3775 2.08182 11.6787 2.35613 11.6869 2.7542V3.44101H15.8064V2.7542C15.8092 2.64213 15.8195 2.6057 15.8408 2.5397C15.9322 2.26332 16.2134 2.06738 16.507 2.06738C16.8707 2.08182 17.1718 2.35613 17.18 2.7542V3.44101H17.8689C17.893 3.44101 17.893 3.44101 17.9177 3.4417C18.9696 3.47401 19.906 4.37945 19.9266 5.47532C19.9514 9.60445 19.9266 13.7336 19.9266 17.862C19.9197 18.9269 19.0157 19.8991 17.8923 19.9197C13.3053 19.9479 8.71829 19.9204 4.13198 19.9204C3.06085 19.9135 2.09492 18.9929 2.07429 17.8861C2.04817 13.7569 2.0736 9.62782 2.0736 5.4987C2.08048 4.42482 3.00998 3.44788 4.13198 3.44101H4.82017V2.7542C4.82292 2.64213 4.83323 2.6057 4.85454 2.5397C4.94598 2.26332 5.22717 2.06738 5.52073 2.06738C5.6321 2.0722 5.66923 2.0832 5.73454 2.10657C6.0006 2.20007 6.18829 2.46957 6.19379 2.7542V5.50076C6.18485 5.94007 5.70154 6.29688 5.27942 6.14838C5.01335 6.05488 4.82635 5.78538 4.82017 5.50076V4.81326C4.58848 4.81257 4.35679 4.81257 4.1251 4.81395C3.77035 4.82082 3.4541 5.13363 3.44723 5.49251C3.42179 9.61751 3.42179 13.7432 3.44723 17.8689C3.4541 18.2243 3.76623 18.5399 4.1251 18.5468C8.70867 18.5749 13.2922 18.5749 17.8751 18.5468C18.2305 18.5399 18.5461 18.2278 18.553 17.8689C18.5784 13.7432 18.5784 9.61751 18.553 5.49182C18.5468 5.1357 18.2388 4.8167 17.8641 4.81395H17.18V5.50076C17.1697 6.00607 16.5056 6.37732 16.0745 6.04457C15.9082 5.9167 15.8105 5.71251 15.8064 5.50076V4.81395H11.6869ZM5.50698 15.8002C5.88579 15.8002 6.19379 16.1082 6.19379 16.487C6.19379 16.8658 5.88579 17.1738 5.50698 17.1738C5.12817 17.1738 4.82017 16.8658 4.82017 16.487C4.82017 16.1082 5.12817 15.8002 5.50698 15.8002ZM8.25354 15.8002C8.63236 15.8002 8.94035 16.1082 8.94035 16.487C8.94035 16.8658 8.63236 17.1738 8.25354 17.1738C7.87473 17.1738 7.56673 16.8658 7.56673 16.487C7.56673 16.1082 7.87473 15.8002 8.25354 15.8002ZM11.0001 15.8002C11.3789 15.8002 11.6869 16.1082 11.6869 16.487C11.6869 16.8658 11.3789 17.1738 11.0001 17.1738C10.6213 17.1738 10.3133 16.8658 10.3133 16.487C10.3133 16.1082 10.6213 15.8002 11.0001 15.8002ZM5.50698 13.0536C5.88579 13.0536 6.19379 13.3616 6.19379 13.7404C6.19379 14.1193 5.88579 14.4273 5.50698 14.4273C5.12817 14.4273 4.82017 14.1193 4.82017 13.7404C4.82017 13.3616 5.12817 13.0536 5.50698 13.0536ZM8.25354 13.0536C8.63236 13.0536 8.94035 13.3616 8.94035 13.7404C8.94035 14.1193 8.63236 14.4273 8.25354 14.4273C7.87473 14.4273 7.56673 14.1193 7.56673 13.7404C7.56673 13.3616 7.87473 13.0536 8.25354 13.0536ZM11.0001 13.0536C11.3789 13.0536 11.6869 13.3616 11.6869 13.7404C11.6869 14.1193 11.3789 14.4273 11.0001 14.4273C10.6213 14.4273 10.3133 14.1193 10.3133 13.7404C10.3133 13.3616 10.6213 13.0536 11.0001 13.0536ZM13.7467 13.0536C14.1255 13.0536 14.4335 13.3616 14.4335 13.7404C14.4335 14.1193 14.1255 14.4273 13.7467 14.4273C13.3679 14.4273 13.0599 14.1193 13.0599 13.7404C13.0599 13.3616 13.3679 13.0536 13.7467 13.0536ZM16.4932 13.0536C16.872 13.0536 17.18 13.3616 17.18 13.7404C17.18 14.1193 16.872 14.4273 16.4932 14.4273C16.1144 14.4273 15.8064 14.1193 15.8064 13.7404C15.8064 13.3616 16.1144 13.0536 16.4932 13.0536ZM8.25354 10.3071C8.63236 10.3071 8.94035 10.6151 8.94035 10.9939C8.94035 11.3727 8.63236 11.6807 8.25354 11.6807C7.87473 11.6807 7.56673 11.3727 7.56673 10.9939C7.56673 10.6151 7.87473 10.3071 8.25354 10.3071ZM11.0001 10.3071C11.3789 10.3071 11.6869 10.6151 11.6869 10.9939C11.6869 11.3727 11.3789 11.6807 11.0001 11.6807C10.6213 11.6807 10.3133 11.3727 10.3133 10.9939C10.3133 10.6151 10.6213 10.3071 11.0001 10.3071ZM13.7467 10.3071C14.1255 10.3071 14.4335 10.6151 14.4335 10.9939C14.4335 11.3727 14.1255 11.6807 13.7467 11.6807C13.3679 11.6807 13.0599 11.3727 13.0599 10.9939C13.0599 10.6151 13.3679 10.3071 13.7467 10.3071ZM16.4932 10.3071C16.872 10.3071 17.18 10.6151 17.18 10.9939C17.18 11.3727 16.872 11.6807 16.4932 11.6807C16.1144 11.6807 15.8064 11.3727 15.8064 10.9939C15.8064 10.6151 16.1144 10.3071 16.4932 10.3071Z"
                  fill="#BC0909"
                />
              </g>
              <defs>
                <clipPath id="clip0_13441_2960">
                  <rect width="22" height="22" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </button>
        </div>
      ),
    },
  ];

  return (
    <>
      <Modal
        isOpen={cardModal}
        onRequestClose={onCloseModal}
        contentLabel="Details Modal"
        ariaHideApp={false}
      >
        <div className={`createNewCTOModalContainer`}>
          <div className="flexBetween">
            {filterType !== "tsar" && (
              <div className="innerGlobalGymANdDatesFilterContainer">
                {filterType !== "monthly_target" && (
                  <div className="commonWrapper dateCommonWrapper">
                    <input
                      type="date"
                      className="date-input"
                      value={startAndEndDate.startDate}
                      onChange={(e) =>
                        setStartAndEndDate({
                          startDate: e.target.value,
                          endDate: e.target.value,
                        })
                      }
                      max={moment().tz("Asia/Kolkata").format("YYYY-MM-DD")}
                    />
                  </div>
                )}
              </div>
            )}

            <ModalHeadAndClose
              title={`${filterType === "tsar" ? "All PT Details" : ""}`}
              onClose={onCloseModal}
            />
          </div>

          {filterType === "tsar" ? (
            <TrainerInfo prevFilters={tdFilters} />
          ) : (
            <AttendanceHistoryDetails
              loading={loading}
              clickedCard={
                filterType === "monthly_target" ? "targets" : "attendance"
              }
              gymsData={allGymsTAData}
              tdFilters={tdFilters}
              selectedDatesQueryParam={selectedDatesQueryParam}
              decryptedText={decryptedText}
            />
          )}
        </div>
      </Modal>

      <Modal
        isOpen={trainerDetailsInfo.trainerDetailsModal}
        onRequestClose={() => setTrainerDetailsInfo(initialTrainerDetailsInfo)}
        contentLabel="Trainer Details"
        ariaHideApp={false}
      >
        <div className="createNewCTOModalContainer cloud-bg-k borderRadiusTen">
          <ModalHeadAndClose
            title="Trainer Details"
            onClose={() => setTrainerDetailsInfo(initialTrainerDetailsInfo)}
          />

          <TrainerDetailsPage
            trainerDetailsInfo={trainerDetailsInfo.trainerDetailsData}
            newQueryParametersForAll={queryParametersForAll}
            decryptedText={decryptedText}
          />
        </div>
      </Modal>

      <div className="pt-track-stats-data personal-training mb30">
        <Accordion>
          <Accordion.Item eventKey="0">
            <Accordion.Header>All Trainers</Accordion.Header>

            <Accordion.Body>
              <main>
                <>
                  {/* <header className="flex-k my-2-k js-end-k gap-05-k">
        <button
          onClick={() => setIsExpertiseModalOpen(true)}
          className="btn-k btn-primaryOutlined-k fs-normal-text flex-k items-end-k"
        >
          <Icons name={"plus"} /> Add Expertise
        </button>
        <button
          onClick={() => setIsTrainerModalOpen(true)}
          className="btn-k fs-normal-text btn-primary-k"
        >
          <Icons name={"plus"} /> Add Trainer
        </button>
      </header> */}

                  {/* {isAdmin && (
        <TrainerFilter
        name="gym"
          decryptedText={decryptedText}
          selectedGym={selectedGym}
          setSelectedGym={setSelectedGym}
        />
      )} */}
                </>

                <>
                  {/* <div className="grid-k my-2-k gap-1-k grid-col-4-k">
            <TSARCard
              onClick={() => {}}
              cardTitle={"Total Trainers"}
              icon={trainer}
              amount={`${
                tsarStatsData?.total_trainers
                  ? parseFloat(tsarStatsData.total_trainers)?.toFixed()
                  : 0
              }`}
            />
            <TSARCard
              onClick={() => {}}
              cardTitle={"Salaries Expense"}
              icon={rupee}
              amount={`₹${
                tsarStatsData?.total_salary_expense
                  ? parseFloat(tsarStatsData.total_salary_expense)?.toFixed()
                  : 0
              }`}
            />
            <TSARCard
              cardTitle={"Average sale value"}
              onClick={() => {}}
              icon={average}
              amount={`₹${
                tsarStatsData?.average_sale_value
                  ? parseFloat(tsarStatsData.average_sale_value)?.toFixed()
                  : 0
              }`}
            />
            <TSARCard
              onClick={() => {}}
              cardTitle={"ROI"}
              icon={roi}
              amount={`${
                tsarStatsData?.roi_percentage
                  ? parseFloat(tsarStatsData.roi_percentage)?.toFixed()
                  : 0
              }%`}
            />
          </div> */}
                </>

                <>
                  {/* <div className="cards-container cards-grid-container threeGridSystem card-y-large">
            {tssrsLoading ? (
              <ReactVortoxSpinner />
            ) : (
              <TEPLargeCard
                cardName={"trainer-details"}
                filterType={"tsar"}
                cardImg={trainer}
                totalTrainers={
                  tsarStatsData?.total_trainers
                    ? parseFloat(tsarStatsData.total_trainers)?.toFixed()
                    : 0
                }
                totalSalaryExpense={
                  tsarStatsData?.total_salary_expense
                    ? parseFloat(tsarStatsData.total_salary_expense)?.toFixed()
                    : 0
                }
                avgSaleValue={
                  tsarStatsData?.average_sale_value
                    ? parseFloat(tsarStatsData.average_sale_value)?.toFixed()
                    : 0
                }
                roi={
                  tsarStatsData?.roi_percentage
                    ? parseFloat(tsarStatsData.roi_percentage)?.toFixed()
                    : 0
                }
                cardTitle={"All Over Trainer Detail"}
                onClickCard={onClickCard}
              />
            )}

            {tmtaLoading ? (
              <ReactVortoxSpinner />
            ) : (
              <>
                <TEPLargeCard
                  cardName={"trainer-details"}
                  filterType={"attendance"}
                  cardImg={totalSubsImg}
                  totalCheckins={total_checkin || 0}
                  lateCheckins={total_late_checkins || 0}
                  totalOnTimeCheckins={total_onTimeCheckins || 0}
                  cardTitle={"Attendance"}
                  onClickCard={onClickCard}
                  checkinsPer={
                    checkin_percentage
                      ? parseFloat(checkin_percentage || 0).toFixed()
                      : 0
                  }
                  missedCheckinsPer={
                    missed_checkins_percentage
                      ? parseFloat(missed_checkins_percentage || 0).toFixed()
                      : 0
                  }
                />

                <TEPLargeCard
                cardName={"trainer-details"}
                filterType={"monthly_target"}
                cardImg={totalSubsImg}
                targetValues={allTargetsData}
                targetAssigned={allTargetsData?.target_value || 0}
                targetAchieved={targetAchievedData || 0}
                cardTitle={"Monthly Target"}
                onClickCard={onClickCard}
                isAdmin={true}
              />
              </>
            )}

            <Attendance
            decryptedText={decryptedText}
            sendableQPs={sendableQPs}
            queryParametersForAll={queryParametersForAll}
            isAdmin={true}
          />
          <LateCheckins
            decryptedText={decryptedText}
            sendableQPs={sendableQPs}
            queryParametersForAll={queryParametersForAll}
          />

            <MonthlyTarget
            classToBeAdded={"spanTwo"}
            decryptedText={decryptedText}
            sendableQPs={sendableQPs}
            queryParametersForAll={queryParametersForAll}
            isAdmin={true}
          />

            <PTMissed
          decryptedText={decryptedText}
          queryParametersForAll={queryParametersForAll}
          isAdmin={true}
        />
          </div> */}
                </>

                <FiltersTrainerDetails
                  name={"trainer-details-admin"}
                  filters={tdFilters}
                  setFilters={setTdFilters}
                  onClickReset={onClickReset}
                  onClickSearch={onClickSearch}
                  handleKeyPress={handleKeyPress}
                />

                {/* <div>
                  <header className="flex-k mx-2 js-between-k items-center-k mt30">
                    <h4 className="bolder-text fs-med-k dark-text">
                      All Trainers
                    </h4>
                  </header>
                </div> */}

                <div>
                  <LightTable data={trainersData} columns={allTrainerCols} />
                </div>
                <div>
                  <PaginationLight
                    isPage={isPage}
                    onChangePage={setIsPage}
                    pagination={trainersPagination}
                  />
                </div>
              </main>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </div>

      <ReactModal
        onRequestClose={() => setIsExpertiseModalOpen(false)}
        isOpen={isExpertiseModalOpen}
        ariaHideApp={false}
      >
        <Suspense fallback={<Loader />}>
          <div className="modal-body-k bg-white rounded-5">
            <ModalHeader
              title={"Add Expertise"}
              onClick={() => setIsExpertiseModalOpen(false)}
            />
            <AddExpertise />
          </div>
        </Suspense>
      </ReactModal>

      <ReactModal
        onRequestClose={() => setIsTrainerModalOpen(false)}
        isOpen={isTrainerModalOpen}
        ariaHideApp={false}
      >
        <Suspense fallback={<Loader />}>
          <div className="modal-body-k bg-white rounded-5">
            <ModalHeader
              title={"Add Trainer"}
              onClick={() => setIsTrainerModalOpen(false)}
            />
            <AddTrainer />
          </div>
        </Suspense>
      </ReactModal>

      <ReactModal
        onRequestClose={() =>
          setActions({
            ...actions,
            actionModal: false,
          })
        }
        isOpen={actions.actionModal}
        ariaHideApp={false}
      >
        <Suspense fallback={<Loader />}>
          <div className="createNewCTOModalContainer customModal manageShift">
            <ModalHeadAndClose
              title="Manage shift timing"
              onClose={() =>
                setActions({
                  ...actions,
                  actionModal: false,
                })
              }
            />

            <ManageTrainerShifts
              decryptedText={decryptedText}
              trainerInfo={actions}
              initialAction={() => setActions(initalActions)}
              callFunction={() =>
                dispatch(
                  fetchAllTrainersData({
                    pageNo: isPage + 1,
                    queryParameters: `&is_pt=1` + queryParametersForAll,
                    token: decryptedText?.token,
                  })
                )
              }
            />
          </div>
        </Suspense>
      </ReactModal>

      <ReactModal
        onRequestClose={() =>
          setActions({
            ...actions,
            shiftDaysModal: false,
          })
        }
        isOpen={actions.shiftDaysModal}
        ariaHideApp={false}
      >
        <Suspense fallback={<Loader />}>
          <div className="createNewCTOModalContainer customModal manageShift">
            <ModalHeadAndClose
              title="Manage shift timing"
              onClose={() =>
                setActions({
                  ...actions,
                  shiftDaysModal: false,
                })
              }
            />

            <ManageTrainerShiftDays
              decryptedText={decryptedText}
              trainerInfo={actions}
              initialAction={() => setActions(initalActions)}
              callFunction={() =>
                dispatch(
                  fetchAllTrainersData({
                    pageNo: isPage + 1,
                    queryParameters: `&is_pt=1` + queryParametersForAll,
                    token: decryptedText?.token,
                  })
                )
              }
            />
          </div>
        </Suspense>
      </ReactModal>
    </>
  );
};

export default TrainerDetailsAdmin;
